import React from "react";
import { Grid, Typography } from "@sumprio/ui";

type TextFilePreviewPanelProps = {
  loading: boolean;
  error: boolean;
  content: string | null;
  classNamePrefix: "view-document-modal" | "view-attachment-modal";
};

export function TextFilePreviewPanel({
  loading,
  error,
  content,
  classNamePrefix,
}: TextFilePreviewPanelProps) {
  if (loading) {
    return (
      <Grid
        display="flex"
        flexDirection="column"
        alignItems="center"
        justifyContent="center"
        padding="2xl"
      >
        <Typography variant="body" bodySize="md" bodyWeight="regular" color="secondary">
          Loading…
        </Typography>
      </Grid>
    );
  }

  if (error || content === null) {
    return (
      <Grid
        display="flex"
        flexDirection="column"
        alignItems="center"
        justifyContent="center"
        gap="md"
        padding="2xl"
        className={`${classNamePrefix}__fallback`}
      >
        <Typography variant="body" bodySize="md" bodyWeight="regular" color="secondary">
          Could not load text preview. You can still try downloading.
        </Typography>
      </Grid>
    );
  }

  return (
    <div className={`${classNamePrefix}__text-preview`}>
      <pre className={`${classNamePrefix}__text-pre`}>{content}</pre>
    </div>
  );
}
